<template>
  <main
    class="text-white relative z-30 h-full flex justify-center items-center"
  >
    <Teleport to="body">
      <div
        class="ombre2 fixed inset-0 opacity-50 aspect-square w-full h-full"
      ></div>
    </Teleport>
    <div
      class="relative aspect-square max-w-lg flex justify-center items-center w-fit m-auto z-40"
    >
      <div class="absolute w-full max-w-5xl">
        <img
          src="../assets/images/caddie-min.png"
          class="absolute hidden md:block w-72 lg:w-80 -left-36 lg:-left-48 xl:-left-80 -top-6 lg:-top-28"
        />
      </div>
      <div class="aspect-square">
        <p class="text-4xl uppercase">Le jeu est à présent terminé !</p>
        <p class="text-2xl py-4">
          Pour en savoir plus sur nos actualités, rendez-vous sur
          <br />
          <a href="https://www.kinder.com/fr" target="_blank"
            ><button class="my-4 mt-8 m-auto bg-red-700 text-white px-16">
              KINDER.COM/FR
            </button></a
          >

          <span class="block py-1 text-center w-full">ET</span>

          <a href="https://www.nutella.com/fr" target="_blank"
            ><button class="mt-4 m-auto bg-red-700 text-white px-16">
              NUTELLA.COM/FR
            </button></a
          >
        </p>

        <p class="!font-neue text-sm leading-3 my-8">
          Pour connaître les modalités de participation,<br />
          consultez le
          <a
            href="https://oxoformdocs.fra1.digitaloceanspaces.com/6ab5213da6298f733bc73670/reglement.pdf"
            class="underline font-neue text-sm"
            target="_blank"
            >règlement</a
          >
        </p>
      </div>
    </div>
  </main>
</template>
<script>
import Teleport from "vue2-teleport";

export default {
  components: {
    Teleport,
  },
};
</script>

<style scoped>
p {
  @apply font-veneer  w-full text-center;
}

.ombre2 {
  background-image: url("@/assets/images/flou-min.png");
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
